/**
 * @author Sagar <sagar.bhattacharya@314ecorp.com>
 * @description URL Constants.
 */

import _ from 'lodash';

export const DEFAULT_SERVER_URL = 'https://test11.api.zsegment.tech/api/v1';

// Keycloak
export const AUTH_URL_INTEGRATION = 'https://auth.314ecorp.tech/auth';
export const AUTH_URL_PRODUCTION = 'https://auth.314ecorp.com/auth';

// lsp url
const DEFAULT_LSP_SERVER_URL = 'ws://test11.api.zsegment.tech/lsp';

// linting server url
const DEFAULT_LINTING_SERVER_URL = 'https://test11.api.zsegment.tech';

export const AUTH_CLIENT = 'zsegment';

export const CONTACT_US_URL = 'https://www.314e.com/contact-us/';

export const URLS = {
	login: '/login',
	rootUrl: '/*',
	certificates: 'certificates',
	settings: '/settings/*',
	managementPage: '/management/*',
	interfaces: '/interfaces',
	schema: 'schema',
	schemaEditor: '/schema/:id',
	functions: 'functions',
	logs: '/logs',
	messages: '/messages',
	libraries: 'libraries',
	testing: '/testing',
	messageMetric: '/message-metric',
	connectors: '/connectors',
	messageEditor: 'messages/:id',
	artifact: '/libraries/artifact/:libraryId',
	interfaceDetails: '/interfaces/:interfaceName/:tab',
	jarClasses: '/libraries/jar/:libraryId',
	tasks: 'tasks',
	connectorDetails: 'connectors/:connectorName/:connectorId',
	interfaceMigration: '/interface-migration',
	schemaTemplate: '/schema/template',
	datasources: 'datasources',
	messageIndices: 'message-indices',
	credentials: 'credentials',
	mavenArtifactManagement: 'maven-artifact-management',
	insights: '/insights',
	taskScripts: '/tasks/scripts',
	taskDetails: 'tasks/:taskName',
	taskManagement: '/management/tasks',
	billingAndSubscriptions: '/settings/billing-subscription',
	profile: '/settings/profile',
	libraryManagement: '/management/libraries',
	documentation: '/documentation',
	automation: '/automation',
};

const getBasename = (): string => {
	const wBranchname = _.isEmpty(_.get(window, 'branchname')) ? undefined : _.get(window, 'branchname');
	const wBasename = _.get(window, 'basename');
	const basename = _.compact([wBranchname, wBasename]);
	return _.isEmpty(basename) ? '' : `/${_.join(basename, '/')}`;
};

const getServerUrl = (): string => {
	const hostName = window.location.hostname;
	const tenant = hostName.split('.')[0];
	const apexDomain = hostName.split('.').slice(-2).join('.');

	if (hostName === 'localhost') {
		return DEFAULT_SERVER_URL;
	}
	return `https://${tenant}.api.${apexDomain}/api/v1`;
};

const getLspServerUrl = (languageId: string): string => {
	const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
	const hostName = window.location.hostname;
	const tenant = hostName.split('.')[0];
	const apexDomain = hostName.split('.').slice(-2).join('.');
	if (hostName === 'localhost') {
		return `${DEFAULT_LSP_SERVER_URL}/${languageId}`;
	}
	return `${protocol}://${tenant}.api.${apexDomain}/lsp/${languageId}`;
};

const getLintingServerEndpoint = (path: string): string => {
	const hostName = window.location.hostname;
	const tenant = hostName.split('.')[0];
	const apexDomain = hostName.split('.').slice(-2).join('.');
	if (hostName === 'localhost') {
		return `${DEFAULT_LINTING_SERVER_URL}/lint/${path}`;
	}
	return `https://${tenant}.api.${apexDomain}/lint/${path}`;
};

export { getBasename, getServerUrl, getLspServerUrl, getLintingServerEndpoint };
